import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  calculateNetIncome,
  editEmployeeIncome,
  editEmployeeIncomeDeduction,
  exportPaySlip,
  getAllowancesData,
  getAuditLogIncomeAndDuection,
  getDataForPaySlip,
  getEmployeeIncomeDeduction,
  getEmployeeIncomeDeductionForSetup,
  getStepTaxData
} from "../services/salaryApi";

import {
  SALARY_SLICE,
  setAllowancesData,
  setAuditLogIncomeAndDuections,
  setIncomeDeduction,
  setIncomeDeductionSetup,
  setIsLoading,
  setPaySlipData,
  setStepTaxData,
  setTotalNetIncome
} from "../slices/salarySlice";

import { Button, Col, ConfigProvider, Flex, Modal, Row, Switch, Tabs } from "antd";
import TableAntd from "components/elements/Table";
import { get2DecimalPointsWithCommas } from "components/numberFormatDigits";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import EmployeeSalaryTaxDetail from "../components/EmployeeSalaryTaxDetail";
import { filter } from "d3";

function useEmployeeSalaryIncomDeduction() {
  const dispatch = useDispatch();
  const { i18n, t } = useTranslation()
  const params = useParams();
  const employeeId = params?.id
  const { currentCompany, currentEmployee } = useSelector((state) => state.company);
  const [isAmountVisible, setIsAmountVisible] = useState(false);
  const [income, setIncome] = useState([])
  const [deduction, setDeduction] = useState();
  const [modalType, setModalType] = useState();
  const [isModalOpen, setIsModalOpen] = useState();
  const [isModalOpenHistory, setIsModalOpenHistory] = useState();
  const [dataIncome, setDataIncome] = useState();
  const [dataDeduct, setDataDeduct] = useState();
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [selectedMenu, setMenu] = useState();
  const [shouldRefreshTaxData, setShouldRefreshTaxData] = useState(false);

  const {
    isLoading,
    incomeDeduction,
    incomeDeductionSetup,
    totalNetIncome,
    paySlipData,
    stepTaxData,
    auditLogIncomeAndDuections,
    allowancesData } = useSelector((state) => state?.[SALARY_SLICE]);


  const onSetupIncomeDeduction = useCallback((type) => {
    setModalType(type)
    setIsModalOpen(true)
  }, [])
  const getEmployeeIncomeDeductionSetup = useCallback(async () => {
    try {
      // dispatch(setIsLoading(true));
      const response = await getEmployeeIncomeDeductionForSetup({
        companyId: currentCompany,
        employeeId: employeeId
      })
      dispatch(setIncomeDeductionSetup(response?.data?.content))
    } catch (error) {
      alert({ type: "error", resultObject: error });
    } finally {
      // dispatch(setIsLoading(false));
    }
  }, [currentCompany, employeeId])

  const onCancel = useCallback(() => {
    setIsModalOpen(false)
    getEmployeeIncomeDeductionSetup()
  }, [getEmployeeIncomeDeductionSetup])


  const handleOk = useCallback(() => {
    setIsModalOpen(false)
    editEmployeeIncomes()
    // switch (modalType) {
    //   case "income":
    //     editEmployeeIncomes()
    //     break;
    //   case "deduction":
    //     editEmployeeDeductions()
    //     break;
    //   default:
    //     break;
    // }
    // getEmployeeIncomeDeductionSetup()
    // getEmployeeIncomeDeductionFn()
    // getAuditLogIncomeAndDuections()

  }, [currentCompany, currentEmployee, employeeId, income, modalType, deduction, dataIncome, dataDeduct])

  const handleMenuChange = useCallback(
    (e) => {
      setMenu(e);
    },
    [setMenu]
  );

  const onMenuClick = (e) => {
    const key = e.key;
    setSelectedKeys([key]);
    handleMenuChange(key);
  };

  const editEmployeeIncomes = useCallback(async () => {
    try {
      setIsModalOpen(false)
      console.log("incomeDeduction?.deduction", income);

      const modifiedIncome = income?.filter(o => o.statusFlag == 'Y')
        ?.map(o => ({
          ...o,
          income: incomeDeduction?.income.find(o1 => o1.id == o.id)?.income ?? o.income,
          amount: dataIncome.find(o2 => o.id == o2.id)?.amount || dataIncome.find(o1 => o?.income?.code?.match("(I01)") && o1.income?.code?.match("(I01)") && o1.statusFlag == 'Y')?.amount || 0
        }));

      const modifiedDeduct = deduction?.filter(o => o.statusFlag == 'Y')
        ?.map(o => ({
          ...o,
          deduction: incomeDeduction?.deduction.find(o1 => o1.id == o.id)?.deduction ?? o.deduction,
          amount: dataDeduct.find(o2 => o.id == o2.id)?.amount || dataDeduct.find(o2 => o?.deduction?.code?.match("(D14|D11|D01|D13|D12)") && o2.deduction?.code?.match("(D14|D11|D01|D13|D12)") && o2.statusFlag == 'Y')?.amount || 0
        }));

      setDataIncome(modifiedIncome)
      setDataDeduct(modifiedDeduct)
      // setDataIncome(modifiedIncome)
      // setDataDeduct(modifiedDeduct)
      // setIncome()

      console.log("income", income, deduction, modifiedIncome, modifiedDeduct);

      dispatch(setIsLoading(true));

      // await editEmployeeIncomeDeduction({
      //   employeeIncomeDeductionId: incomeDeduction?.employeeIncomeDeductionId,
      //   companyId: currentCompany,
      //   employeeId: employeeId,
      //   incomeListId: modifiedIncome,
      //   deductionListId: modifiedDeduct,
      // });

      // getEmployeeIncomeDeductionSetup()
      // getEmployeeIncomeDeductionFn()
      // getAuditLogIncomeAndDuections()

    } catch (error) {
      alert({ type: "error", resultObject: error });
    } finally {
      dispatch(setIsLoading(false));
    }
  }, [currentCompany, employeeId, income, incomeDeduction, deduction])

  // const editEmployeeDeductions = useCallback(async () => {
  //   try {
  //     setIsModalOpen(false)
  //     const modifiedDeduction = deduction?.map((o) => ({
  //       incomeDeductionId: o?.deduction?.id,
  //       statusFlag: o?.statusFlag,
  //       amount: o?.amount,
  //       code: o?.code
  //     }));
  //     dispatch(setIsLoading(true));
  //     await editEmployeeDeduction({
  //       employeeIncomeDeductionId: incomeDeduction?.employeeIncomeDeductionId,
  //       companyId: currentCompany,
  //       employeeId: employeeId,
  //       deductionListId: modifiedDeduction,
  //     })
  //     getEmployeeIncomeDeductionSetup()
  //     getEmployeeIncomeDeductionFn()
  //     getAuditLogIncomeAndDuections()

  //   } catch (error) {
  //     alert({ type: "error", resultObject: error });
  //   } finally {
  //     dispatch(setIsLoading(false));
  //   }
  // }, [currentCompany, employeeId, deduction, incomeDeduction])



  const getAuditLogIncomeAndDuections = useCallback(async () => {
    try {
      // dispatch(setIsLoading(true));
      const response = await getAuditLogIncomeAndDuection({
        companyId: currentCompany,
        employeeId: employeeId,
      })
      // console.log("response ", response?.data);
      dispatch(setAuditLogIncomeAndDuections(response?.data))
      console.log("auditLogIncomeAndDuections ", auditLogIncomeAndDuections);
    } catch (error) {
      alert({ type: "error", resultObject: error });
    } finally {
      // dispatch(setIsLoading(false));
    }
  }, [currentCompany, dispatch, employeeId, auditLogIncomeAndDuections])


  const getEmployeeIncomeDeductionFn = useCallback(async () => {
    try {
      // dispatch(setIsLoading(true));
      const response = await getEmployeeIncomeDeduction({
        companyId: currentCompany,
        employeeId: employeeId,
        visible: isAmountVisible,
        isEdit: isAmountVisible
      })
      console.log("response?.data?.content", response?.data?.content);

      dispatch(setIncomeDeduction(response?.data?.content))

      setShouldRefreshTaxData(true);
    } catch (error) {
      alert({ type: "error", resultObject: error });
    } finally {
      // dispatch(setIsLoading(false));
    }
  }, [currentCompany, currentEmployee, employeeId, incomeDeductionSetup, isAmountVisible])

  const calculateNetIncomeFn = useCallback(async (values) => {
    // console.log("🚀 ~ calculateNetIncomeFn ~ income:", income)
    try {
      dispatch(setIsLoading(true));

      const modifiedIncome = values?.incomes?.map(({ id, modified, incomeType, income, amount }) => ({
        id,
        incomeDeductionId: income?.id,
        amount,
        statusFlag: income?.statusFlag ? income?.statusFlag : 'Y',
        code: income?.code,
        income: income,
        modified: modified,
        incomeType
      }));
      // setIncome(modifiedIncome)
      const modifiedDeduction = values?.deductions?.map(({ id, modified, deductionType, deduction, amount }) => ({
        id,
        incomeDeductionId: deduction?.id,
        amount,
        statusFlag: deduction?.statusFlag ? deduction?.statusFlag : 'Y',
        code: deduction?.code,
        deduction: deduction,
        modified: modified,
        deductionType: deductionType
      }));
      console.log("values?.deductions", values?.deductions, modifiedDeduction);

      // setDeduction(modifiedDeduction)

      const response = await calculateNetIncome({
        companyId: currentCompany,
        employeeId: employeeId,
        incomeListId: modifiedIncome,
        deductionListId: modifiedDeduction,
        employeeIncomeDeductionId: incomeDeduction?.employeeIncomeDeductionId,
      })
      dispatch(setIncomeDeduction(response?.data?.content))
    } catch (error) {
      alert({ type: "error", resultObject: error });
    } finally {
      dispatch(setIsLoading(false));
    }
  }, [currentCompany, currentEmployee, employeeId, incomeDeduction])


  const totalIncomeComponent = useMemo(() => {
    return (
      <span style={{ fontSize: "30px" }}>
        {isAmountVisible ? get2DecimalPointsWithCommas(totalNetIncome) : "XXXX.XX"}
      </span>
    );
  }, [totalNetIncome, isAmountVisible]);



  const taxColumn = [
    {
      title: <span style={{ fontWeight: "normal", display: "flex", justifyContent: "center" }}>{t("salary.label.netIncomeLevel")}</span>,
      key: "netIncomeLevel",
      index: "netIncomeLevel",
      width: "25%",
      render: (_, record) => {
        return (<span style={{ display: "flex", justifyContent: "flex-end" }}>{get2DecimalPointsWithCommas(record?.netIncomeLevel)} {t('unit.baht')}</span>)
      }
    },
    {
      title: <span style={{ fontWeight: "normal", display: "flex", justifyContent: "center" }}>{t("salary.label.netIncomeAtLevel")}</span>,
      key: "netIncomeAtLevel",
      index: "netIncomeAtLevel",
      width: "25%",
      render: (_, record) => {
        return (<span style={{ display: "flex", justifyContent: "flex-end" }}>{get2DecimalPointsWithCommas(record?.netIncomeAtLevel)} {t('unit.baht')}</span>)
      }
    },
    {
      title: <span style={{ fontWeight: "normal", display: "flex", justifyContent: "center" }}>{t("salary.label.taxRate")}</span>,
      key: "taxRate",
      index: "taxRate",
      width: "25%",
      render: (_, record) => {
        return (<span style={{ display: "flex", justifyContent: "flex-end" }}>{record?.taxRate * 100}</span>)
      }
    },
    {
      title: <span style={{ fontWeight: "normal", display: "flex", justifyContent: "center" }}>{t("salary.label.incomeTax")}</span>,
      key: "incomeTax",
      index: "incomeTax",
      width: "25%",
      render: (_, record) => {
        return (<span style={{ display: "flex", justifyContent: "flex-end" }}>{get2DecimalPointsWithCommas(record?.incomeTax)} {t('unit.baht')}</span>)
      }
    },
  ]

  const getHistoryModal = useCallback(() => {
    const columns = [
      {
        title: <span style={{ fontWeight: "normal", display: "flex", justifyContent: "center" }}>{t("salary.income-deduction"
        )}</span>,
        key: "index",
        index: "index",
        width: "25%",
        render: (_, record) => {

          if (record?.incomeName) {
            return (<span style={{ display: "flex", justifyContent: "center" }}>{i18n.language === "en" ? record?.incomeName?.nameEn : record?.incomeName?.name}</span>)
          }
          if (record?.deductionName) {
            return (<span style={{ display: "flex", justifyContent: "center" }}>{i18n.language === "en" ? record?.deductionName?.nameEn : record?.deductionName?.name}</span>)
          }
        }
      },
      {
        title: <span style={{ fontWeight: "normal", display: "flex", justifyContent: "center" }}>{t("salary.label.oldValue"
        )}</span>,
        key: "index",
        index: "index",
        width: "25%",
        render: (_, record) => {
          return (<span style={{ display: "flex", justifyContent: "center" }}>{get2DecimalPointsWithCommas(record?.oldValue)}</span>)
        }
      },
      {
        title: <span style={{ fontWeight: "normal", display: "flex", justifyContent: "center" }}>{t("salary.label.newValue"
        )}</span>,
        key: "index",
        index: "index",
        width: "25%",
        render: (_, record) => {

          return (<span style={{ display: "flex", justifyContent: "center" }}>{get2DecimalPointsWithCommas(record?.newValue)}</span>)

        }
      },
      {
        title: <span style={{ fontWeight: "normal", display: "flex", justifyContent: "center" }}>{t("salary.label.modified_by"
        )}</span>,
        key: "index",
        index: "index",
        width: "25%",
        render: (_, record) => {
          return (<div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <span>
              {i18n.language === "en" ? `${record?.modifiedBy?.nameEn} ${record?.modifiedBy?.surNameEn}` : `${record?.modifiedBy?.name} ${record?.modifiedBy?.surName}`}
            </span>
            <span style={{ fontSize: "0.85em", color: "gray" }}>
              {record?.modifiedDate ? new Date(record.modifiedDate).toLocaleString(i18n.language) : ""}
            </span>
          </div>
          )

        }
      }
    ]


    return (<Modal
      title={t("employee.label.history")}
      open={isModalOpenHistory}
      closable={false}
      maskClosable={false}
      onCancel={() => setIsModalOpenHistory(false)}
      footer={[
        <Button onClick={() => setIsModalOpenHistory(false)}>{t("common.close")}</Button>
      ]}
      width="100%"
    >


      <TableAntd
        // pagination={false}
        noPage={true}
        loading={isLoading}
        columns={columns}
        dataSource={auditLogIncomeAndDuections}>

      </TableAntd>
    </Modal>)
  }, [getAuditLogIncomeAndDuections, t, isModalOpenHistory, isLoading, auditLogIncomeAndDuections, i18n.language])

  const getModal = useCallback(() => {
    switch (modalType) {
      case "income":
        return (
          <Modal title={t("employee.label.income")}
            open={isModalOpen}
            closable={false}
            onCancel={() => getEmployeeIncomeDeductionSetup()}
            maskClosable={false}
            onOk={(values) => {
              console.log("modal ", values);
            }}
            footer={[
              <Button onClick={onCancel} style={{ borderRadius: "8px", height: "40px" }}>{t("common.cancel")}</Button>,
              <Button
                htmlType="submit"
                type="primary"
                onClick={handleOk}
                style={{ backgroundColor: "var(--button-color)", height: "40px", borderRadius: "8px" }}
              >{t("common.submit")}</Button>
            ]}
            width="30%"
          >
            {income?.map((item, index) => (
              <Row style={{ marginBottom: "16px" }}>
                <Col span={21}>
                  <span>
                    {item?.income.code == "I01" ?
                      i18n.language === "en" ? item?.income.nameEn + ` ( ${item?.incomeType?.incomeNameEn}) ${((item?.deductionWithholdingTax || '') + (item?.deductionWithholdingTax ? "%" : ''))}` : item?.income?.name + ` ( ${item?.incomeType?.incomeName} ${((item?.deductionWithholdingTax || '') + (item?.deductionWithholdingTax ? "%" : ''))} )`
                      : i18n.language === "en" ? item?.income.nameEn : item?.income?.name
                    }
                  </span>
                </Col>
                <Col span={3} style={{ textAlignLast: "end" }}>
                  <Switch
                    checked={item?.statusFlag === 'Y'}
                    // disabled={item?.income?.code === 'I01'}
                    onChange={(e) => {
                      setIncome(income?.map(o => {
                        console.log("income", o, item);
                        if (o?.id === item?.id) {
                          return {
                            ...o,
                            statusFlag: e ? "Y" : "N",
                            code: o?.income?.code,
                            amount: income.find(j => j?.income?.code == "I01" && item.income?.code == "I01" && j.statusFlag == "Y")?.amount ?? o?.amount ?? 0
                          }
                        } else if (o?.income?.code == "I01" && item.income?.code == "I01") {
                          return { ...o, statusFlag: "N" };
                        }
                        return {
                          ...o,
                          code: o?.income?.code,
                        }
                      }
                      ))
                    }}
                  />
                </Col>
              </Row>))}
          </Modal>)

      case "deduction":
        return (<Modal title={t("employee.label.deduction")}
          open={isModalOpen}
          closable={false}
          maskClosable={false}
          onCancel={() => getEmployeeIncomeDeductionSetup()}
          footer={[
            <Button onClick={onCancel} style={{ borderRadius: "8px", height: "40px" }}>{t("common.cancel")}</Button>,
            <Button
              htmlType="submit"
              type="primary"
              onClick={handleOk}
              style={{ backgroundColor: "var(--button-color)", height: "40px", borderRadius: "8px" }}
            >{t("common.submit")}</Button>
          ]}
          width="30%"
        >
          {deduction?.map((item, index) => (
            <Row style={{ marginBottom: "16px" }}>
              <Col span={21}>
                <span>
                  {i18n.language === "en" ? item?.deduction?.nameEn : item?.deduction?.name}
                </span>
              </Col>
              <Col span={3} style={{ textAlignLast: "end" }}>
                <Switch
                  // disabled={item?.deduction?.code === 'D01' || item?.deduction?.code === 'D02'}
                  checked={item?.statusFlag === 'Y'}
                  onChange={(e) => {
                    setDeduction(deduction?.map(o => {
                      if (o?.id === item?.id) {
                        return {
                          ...o,
                          statusFlag: e ? "Y" : "N",
                          code: o?.deduction?.code,
                          amount: deduction.find(j => j?.deduction?.code?.match("(D14|D11|D01|D13|D12)") && item?.deduction?.code?.match("(D14|D11|D01|D13|D12)") && j.statusFlag == "Y")?.amount ?? o?.amount ?? 0
                        }
                      } else if (o?.deduction?.code?.match("(D14|D11|D01|D13|D12)") && item?.deduction?.code?.match("(D14|D11|D01|D13|D12)")) {
                        return { ...o, statusFlag: "N" };
                      }
                      return {
                        ...o,
                        code: o?.deduction?.code
                      }
                    }))
                  }}
                />
              </Col>
            </Row>))}
        </Modal>)



      case "taxComputation":
        const totalNetAllowance = allowancesData
          ?.filter((allowance) =>
            ["PERSONAL_AND_FAMILY", "SOCIAL_SECURITY", "OTHER"].includes(allowance?.code)
          )
          ?.reduce((sum, allowance) => sum + (parseFloat(allowance?.amount) || 0), 0);

        return (<Modal
          title={false}
          open={isModalOpen}
          closable={false}
          maskClosable={false}
          onCancel={() => getEmployeeIncomeDeductionSetup()}
          footer={
            <Flex justify="center">
              <Button onClick={onCancel} style={{ backgroundColor: "var(--button-color)", borderRadius: "8px", fontWeight: "bold", color: "var(--button-text-color)", border: "none" }}>
                {t("common.close")}
              </Button>
            </Flex>
          }
          width="50%"
        >
          <ConfigProvider
            theme={{
              components: {
                Tabs: {
                  itemHoverColor: "var(--tab-color)",
                  itemActiveColor: "var(--tab-color)"
                },
              },
            }}
          >
            <Tabs destroyInactiveTabPane={true} defaultActiveKey={selectedKeys} onChange={onMenuClick}>
              <Tabs.TabPane tab={t('employee.label.allowances')} key={"allowances"}>

                <div style={{ overflowY: "auto", maxHeight: "60vh" }}>
                  {allowancesData?.map((allowance, index) => (
                    <div key={index}>
                      {allowance?.tag === "header" && (
                        <Row justify="space-between" style={{ textIndent: "16px" }}>
                          <Col><span style={{ fontWeight: "bold" }}>{t(`${allowance?.code}.header`)}</span></Col>
                          <Col><span style={{ fontWeight: "bold" }}>{get2DecimalPointsWithCommas(allowance?.amount ? allowance?.amount : "0")} {t("unit.baht")}</span></Col>
                        </Row>)}

                      {allowance?.tag === "category" && (
                        <Row justify="space-between">
                          <Col><span>{t(`${allowance?.code}.header`)}</span></Col>
                          <Col><span>{get2DecimalPointsWithCommas(allowance?.amount ? allowance?.amount : "0")} {t("unit.baht")}</span></Col>
                        </Row>)}

                      {allowance?.tag === "children" && (
                        <Row justify="space-between" style={{ textIndent: "16px" }}>
                          <Col><span>{t(`${allowance?.code}.header`)}</span></Col>
                          <Col><span>{get2DecimalPointsWithCommas(allowance?.amount ? allowance?.amount : "0")} {t("unit.baht")}</span></Col>
                        </Row>)}


                    </div>
                  ))}
                  {/* <Row justify="space-between" style={{ textIndent: "16px" }}>
                    <Col><span style={{ fontWeight: "bold" }}>{t("salary.label.totalNetAllowance")}</span></Col>
                    <Col><span style={{ fontWeight: "bold" }}>{get2DecimalPointsWithCommas(totalNetAllowance ? totalNetAllowance : "0")} {t("unit.baht")}</span></Col>
                  </Row> */}
                </div>
              </Tabs.TabPane>

              <Tabs.TabPane tab={t('salary.label.withholdingTax')} key={"tax"}>
                <EmployeeSalaryTaxDetail stepTaxData={stepTaxData} taxColumn={taxColumn} />
              </Tabs.TabPane>
            </Tabs>
          </ConfigProvider>
        </Modal>)
      default:
        break;
    }
  }, [modalType, isModalOpen, allowancesData, deduction, income, getEmployeeIncomeDeductionSetup, stepTaxData])


  const dataAllowances = useCallback(async () => {
    try {
      // dispatch(setIsLoading(true));
      const response = await getAllowancesData({
        employeeId: employeeId,
        companyId: currentCompany
      })
      dispatch(setAllowancesData(response?.data?.content))
    } catch (error) {
      alert({ type: "error", resultObject: error });
    } finally {
      // dispatch(setIsLoading(false));
    }
  }, [employeeId, currentCompany])

  const editEmployeeIncomeDeductionFn = useCallback(async (values) => {
    try {
      setIsModalOpen(false)
      dispatch(setIsLoading(true));
      await editEmployeeIncomeDeduction({
        employeeIncomeDeductionId: incomeDeduction?.employeeIncomeDeductionId,
        companyId: currentCompany,
        employeeId: employeeId,
        deductionListId: values?.deductions,
        incomeListId: values?.incomes
      })
      getEmployeeIncomeDeductionFn()
      getAuditLogIncomeAndDuections()
      getStepTaxData({
        companyId: currentCompany,
        employeeId: employeeId
      })
      dataAllowances()

    } catch (error) {
      alert({ type: "error", resultObject: error });
    } finally {
      dispatch(setIsLoading(false));
    }
  }, [currentCompany, employeeId, incomeDeduction, getStepTaxData, dataAllowances])

  const onSubmit = useCallback((values) => {
    Modal.confirm({
      title: t("dialog.confirmation.header"),
      content: (
        <>
          <p>
            {t("dialog.confirmation.edit").replace("{entity}", t("payroll.entity"))}
          </p>
        </>
      ),
      onOk() {
        if (values) {

          const modifiedIncome = values?.incomes?.map(({ id, income, incomeType, amount, modified }) => ({
            id,
            incomeDeductionId: income?.id,
            amount,
            code: income?.code,
            incomeType,
            statusFlag: "Y",
            modified
          }));
          const modifiedDeduction = values?.deductions?.map(({ id, deduction, incomeType, deductionType, amount, modified }) => ({
            // const modifiedDeduction = values?.deductions?.filter((o) => o?.deduction?.code !== 'D02' && o?.deduction?.code !== 'D01').map(({ deduction, amount }) => ({
            id,
            incomeDeductionId: deduction?.id,
            amount,
            code: deduction?.code,
            incomeType: deductionType || incomeType,
            statusFlag: "Y",
            modified
          }));
          console.log("modifiedIncome", values?.deductions, modifiedDeduction);

          editEmployeeIncomeDeductionFn({
            incomes: modifiedIncome,
            deductions: modifiedDeduction,
          });
        }
      },
      okText: t("common.confirm").toUpperCase(),
      cancelText: t("common.cancel").toUpperCase(),
    });


  }, [incomeDeduction, currentCompany, employeeId, editEmployeeIncomeDeductionFn])


  const previewPaySlip = useCallback(async (values) => {
    try {
      dispatch(setIsLoading(true));

      const modifiedIncome = values?.incomes
        ?.filter(o => o.amount && o.amount !== 0)
        .map(o => ({
          name: o?.income?.name,
          value: o?.amount,
          unit: o?.unit
        }));

      const modifiedDeduct = values?.deductions
        ?.filter(o => o.amount && o.amount !== 0)
        .map(o => ({
          name: o?.deduction?.name,
          value: o?.amount,
          unit: o?.unit
        }));

      const response = await exportPaySlip({
        "companyImage": paySlipData?.company?.companyImage,
        "companyName": paySlipData?.company?.companyName,
        "employeeNo": paySlipData?.employee?.employeeNo,
        "accountNo": paySlipData?.employee?.accountNo,
        "employeeName": paySlipData?.employee?.employeeName,
        "employeeType": paySlipData?.employee?.employeeType,
        "position": paySlipData?.employee?.position,
        "departmentNo": paySlipData?.employee?.departmentNo,
        "departmentName": paySlipData?.employee?.departmentName,
        "periodNo": paySlipData?.period?.periodNo,
        "periodMax": paySlipData?.periodMax,
        "periodMonth": paySlipData?.period?.month,
        "periodYear": paySlipData?.period?.year,
        "paymentDate": dayjs(paySlipData?.period?.paymentDate).format('DD-MM-YYYY'),
        "employmentDate": dayjs(paySlipData?.employee?.employmentDate).format('DD-MM-YYYY'),
        "netAmount": values?.totalNetIncome,
        "totalIncome": values?.totalIncome,
        "totalDeduction": values?.totalDeduct,
        "yearIncome": "0",
        "yearSocialSecurity": "0",
        "yearTaxIncome": "0",
        "yearFound": "0",
        "yearAllowance": "0",
        "yearAllowance,": "0",
        "totalIncomeAmount": values?.totalIncome,
        "totalDeductAmount": values?.totalDeduct,
        "income": modifiedIncome,
        "deduction": modifiedDeduct,
      })

      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);

      const modal = document.createElement('div');
      modal.style.position = 'fixed';
      modal.style.top = '0';
      modal.style.left = '0';
      modal.style.width = '100%';
      modal.style.height = '100%';
      modal.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
      modal.style.display = 'flex';
      modal.style.alignItems = 'center';
      modal.style.justifyContent = 'center';
      modal.style.zIndex = '9999';

      const iframe = document.createElement('iframe');
      iframe.style.width = '80%';
      iframe.style.height = '80vh';
      iframe.src = url;

      const closeButton = document.createElement('button');
      closeButton.textContent = 'Close';
      closeButton.style.position = 'absolute';
      closeButton.style.top = '20px';
      closeButton.style.right = '20px';
      closeButton.style.padding = '10px 20px';
      closeButton.style.backgroundColor = '#ff0000';
      closeButton.style.color = '#fff';
      closeButton.style.border = 'none';
      closeButton.style.borderRadius = '5px';
      closeButton.style.cursor = 'pointer';
      closeButton.style.fontSize = '16px';

      closeButton.addEventListener('click', () => {
        document.body.removeChild(modal);
        window.URL.revokeObjectURL(url);
      });

      modal.appendChild(iframe);
      modal.appendChild(closeButton);

      document.body.appendChild(modal);

      // download 
      // Create a link element, set its href to a URL created from the blob, and trigger a download
      // const link = document.createElement('a');
      // link.href = window.URL.createObjectURL(blob);
      // link.setAttribute('download', 'payslip.pdf'); // Set the filename
      // document.body.appendChild(link);
      // link.click();
      // link.remove();
    } catch (error) {
      alert({ type: "error", resultObject: error });
    } finally {
      dispatch(setIsLoading(false));
    }
  }, [paySlipData])

  const dataPaySlip = useCallback(async () => {
    try {
      dispatch(setIsLoading(true));
      const response = await getDataForPaySlip({
        employeeId: employeeId,
        companyId: currentCompany
      })
      dispatch(setPaySlipData(response?.data?.content))
    } catch (error) {
      alert({ type: "error", resultObject: error });
    } finally {
      dispatch(setIsLoading(false));
    }
  }, [employeeId, currentCompany])

  const dataStepTax = useCallback(async () => {
    try {
      dispatch(setIsLoading(true));
      const response = await getStepTaxData({
        employeeId: employeeId,
        companyId: currentCompany
      })
      dispatch(setStepTaxData(response?.data?.content))
    } catch (error) {
      alert({ type: "error", resultObject: error });
    } finally {
      dispatch(setIsLoading(false));
    }
  }, [employeeId, currentCompany])




  useEffect(() => {
    const refreshTaxData = async () => {
      if (shouldRefreshTaxData && currentCompany && employeeId) {
        try {
          await dataStepTax();
        } catch (error) {
          console.error('Failed to refresh tax data:', error);
        }
        setShouldRefreshTaxData(false);
      }
    };

    refreshTaxData();
  }, [shouldRefreshTaxData, currentCompany, employeeId, dataStepTax]);

  useEffect(() => {
    if (currentCompany) {
      const fetchAllData = async () => {
        dispatch(setIsLoading(true));
        try {
          await Promise.all([
            getEmployeeIncomeDeductionSetup(),
            getEmployeeIncomeDeductionFn(),
            getAuditLogIncomeAndDuections(),
            dataAllowances()
          ]);
        } catch (error) {
          console.error('Error loading data:', error);
        } finally {
          dispatch(setIsLoading(false));
        }
      };

      fetchAllData();
    }
  }, [currentCompany, isAmountVisible]);


  useEffect(() => {
    dispatch(setTotalNetIncome(0))
  })

  useEffect(() => {
    if (employeeId) {
      dataPaySlip()
    }
  }, [employeeId])


  useEffect(() => {
    if (incomeDeductionSetup?.employeeIncome) {
      const income = incomeDeductionSetup?.employeeIncome?.map((o) => {
        const matchingIncome = incomeDeduction?.income?.find((income) => income?.id === o?.id);
        return {
          ...o,
          income: matchingIncome?.income ?? o.income,
          incomeType: matchingIncome?.incomeType ?? o.incomeType,
          amount: matchingIncome ? matchingIncome?.amount : 0,
          code: matchingIncome?.income?.code,
          statusFlag: matchingIncome ? "Y" : "N",
          modified: matchingIncome?.modified
        };
      })

      setIncome(income)
    }
    if (incomeDeductionSetup?.employeeDeduction) {
      const deduct = incomeDeductionSetup?.employeeDeduction?.map((o) => {

        const matchingDeduct = incomeDeduction?.deduction?.find((deduction) => deduction?.id === o?.id);
        console.log("matchingDeduct", matchingDeduct);
        return {
          ...o,
          deduction: matchingDeduct?.deduction ?? o.deduction,
          deductionType: matchingDeduct?.deductionType ?? o.deductionType,
          amount: matchingDeduct ? matchingDeduct?.amount : 0,
          code: matchingDeduct?.income?.code,
          statusFlag: matchingDeduct ? "Y" : "N",
          modified: matchingDeduct?.modified
        };

      })
      console.log("matchingDeduct", deduct);

      setDeduction(deduct)
    }
  }, [incomeDeductionSetup, incomeDeduction])

  useEffect(() => {
    if (incomeDeduction) {
      console.log("incomeDeduction incomeDeduction", incomeDeduction);

      setDataIncome(incomeDeduction?.income)
      setDataDeduct(incomeDeduction?.deduction)
    }
  }, [incomeDeduction])


  return {
    incomeDeduction,
    incomeDeductionSetup,
    isLoading,
    income,
    deduction,
    getHistoryModal,
    setIncome,
    getModal,
    onSetupIncomeDeduction,
    onSubmit,
    editEmployeeIncome,
    calculateNetIncomeFn,
    totalNetIncome,
    totalIncomeComponent,
    setIsAmountVisible,
    isAmountVisible,
    previewPaySlip,
    dataIncome,
    dataDeduct,
    setDataIncome,
    setDataDeduct,
    setIsModalOpenHistory
  };
}

export default useEmployeeSalaryIncomDeduction;
